module.exports = __webpack_public_path__ + "static/media/ozmosys-logo2.40c961bc.png";